import { IconX as TablerIconX } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconX = /*#__PURE__*/ createOutlineIcon(TablerIconX, 'IconX');
